import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFCheckCircleProps = Omit<SvgIconProps, "color"> & {
  color?: string;
  // width?: number;
  // height?: number;
  // strokeWidth?: number;
};

export default function SFCheckCircleIcon({
  color = "white",
  // width = 24,
  // height = 24,
  // strokeWidth = 2,
  ...props
}: SFCheckCircleProps) {
  return (
    // <SvgIcon {...props}>
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_113_3911)">
        <circle cx="30" cy="30" r="28.5" stroke="#A19BFD" strokeWidth="3" />
        <path
          d="M20 30L27.2692 39L41 22"
          stroke="#A19BFD"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_113_3911">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
    // </SvgIcon>
  );
}
